import { withProtectedResource } from '@delmonicos/shared-design-system-react/src/components/protected-resources/with-protected-resource.helper';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { safeHasAccessTo } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import { ActionsByResource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/action.enum';
import { Resource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/resource.enum';
import { ChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/transaction-service-lib/src/wrapper/outputs/charging-session.model';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { permissions } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';
import i18n from '@app/core/locale/i18n';
import { useEmspBoGetChargingSessionQuery } from '@service/emsp-bo-charging-sessions.service';
import { useSetPageTitleContext } from '@shared/layout/page-layout/page-layout-title.context-provider';

import { EmspBoChargingSessionContextProvider } from '../emsp-bo-charging-session.context';
import { EmspBoChargingSessionDetailsView } from './emsp-bo-charging-session-details.view';

interface EmspBoChargingSessionDetailsControllerProps {
  resource: ChargingSessionModel;
}

const EmspBoChargingSessionDetailsController = ({
  resource,
}: EmspBoChargingSessionDetailsControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // PAGE TITLE ////////////////////////////////////////////////////////////////

  const setPageTitle = useSetPageTitleContext();

  useEffect(() => {
    setPageTitle(
      resource?.startedAt
        ? formatDate(resource.startedAt, i18n)
        : t('$.emsp-bo-charging-session-details.title'),
    );
  }, [setPageTitle, resource, t]);

  // PAGE ACTIONS //////////////////////////////////////////////////////////////

  // Nothing to do

  // PAGE BREADCRUMB ///////////////////////////////////////////////////////////

  // Nothing to do

  // HANDLERS //////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <EmspBoChargingSessionContextProvider data={resource}>
      <EmspBoChargingSessionDetailsView />
    </EmspBoChargingSessionContextProvider>
  );
};

export const EmspBoChargingSessionDetailsPage = (): React.JSX.Element => {
  const userPermissions = useAppSelector(permissions);
  const params = useParams();

  const queryState = useEmspBoGetChargingSessionQuery({
    chargingSessionId: params.id ?? '',
  });

  const { Component } = withProtectedResource<
    ChargingSessionModel,
    {},
    ChargingSessionModel
  >(EmspBoChargingSessionDetailsController, queryState, {
    isAuthorized: () =>
      safeHasAccessTo(userPermissions, {
        resourceName: Resource.EMSP_BO,
        action: ActionsByResource.EMSP_BO.READ_SESSION,
      }),
  })({});

  return Component;
};
